import store from '@/store';
import { EventBus } from '@/event-bus.js';

export default class VoiceTransferResponseEvent {
  constructor(body) {
    window.console.log(
      '[VoiceTransferResponseEvent]',
      JSON.parse(JSON.stringify(body)),
    );
    if (!body.accepted) {
      store.dispatch('jobs/setTransferAssisted', false);
      store.dispatch('jobs/setTransferAssistedAccepted', false);
      store.dispatch('dialogs/closeDialogTransferCallReceived');
      EventBus.$emit('closeDialogTransferCall');
    }

    store.dispatch('jobs/ackCallRequestShowDialog', false);
    store.dispatch('jobs/setAckCallRequestInProgress', false);
  }
}

